import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { analytics } from 'app/utils/segment';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { pubSub } from 'utils/pubSub';
import { TopbarButton } from '../topbarButton';
export const KeyboardCheatSheetTopbarButton = () => {
    const openCheatSheet = useCallback(() => {
        analytics.commandExecuted({
            commandName: 'app:keyboardCheatSheet',
            location: 'topbar',
        });
        pubSub.publish('command:app:keyboardCheatSheet');
    }, []);
    const tooltip = (_jsx(CommandKeybindingsTooltipContent, Object.assign({ commandName: "app:keyboardCheatSheet" }, { children: "Keyboard cheat sheet" })));
    return (_jsx(TopbarButton, { onClick: openCheatSheet, icon: "keyboard", tooltip: tooltip }));
};
